<template>
  <div class="settings-currency">
    <currency-card
      v-for="item in currencyCards"
      :key="item.data.id"
      :data="item.data"
      :loading="item.loading"
      :editable="editableCurrency"
      @startLoading="startLoadingCurrency"
      @finishLoading="finishLoadingCurrency"/>
    <div v-if="loading" class="loader">
      <indicator/>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import Indicator from '@/components/UIComponents/Custom/Indicator'
import CurrencyCard from '@/components/Pages/Settings/CurrencyCard'

export default {
  name: 'Currency',
  components: {
    CurrencyCard,
    Indicator
  },
  data() {
    return {
      loading: false,
      loadingCurrencies: []
    }
  },
  computed: {
    ...mapGetters(['activeRoleName', 'currencyList']),
    currencyCards() {
      if (!this.currencyList.length) return []
      return this.currencyList.map(data => ({
          data,
          loading: this.loadingCurrencies.includes(data.id)
        })
      )
    },
    editableCurrency() {
      return this.activeRoleName === 'superadministrator'
    }
  },
  methods: {
    ...mapMutations(['setCurrencyList']),
    ...mapActions(['getCurrency']),
    async getCurrencyList() {
      this.loading = true
      try {
        await this.getCurrency()
      } finally {
        this.loading = false
      }
    },
    startLoadingCurrency(id) {
      this.loadingCurrencies.push(id)
    },
    finishLoadingCurrency(id) {
      this.loadingCurrencies = this.loadingCurrencies.filter(item => item !== id)
    }
  },
  async beforeMount() {
    await this.getCurrencyList()
  },
  beforeUnmount() {
    this.setCurrencyList([])
  }
}
</script>

<style scoped>

</style>
